import Details from 'components/Details';

const Dashboard = (): JSX.Element => (
  <main className='main'>
    <Details />
  </main>
);

export default Dashboard;
